// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__rcoYQ","input":"Checkbox_input__Ota1r","label":"Checkbox_label__OW4Sw","labeledtext":"Checkbox_labeledtext__WNmKZ"};